var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(!singleChoiceMode) { 
__p+='\n<div class="MenuItemPassive MenuButton" data-invoke="toggleAutoSelect" title="Alle Einträge in der Seitenleiste automatisch beim Wechseln der Favoritengruppe sichtbar schalten bzw. selektieren">\n	<div class="MenuInline MenuIcon">\n		';
 if(autoSelect){ 
__p+='\n		<i class="fa fa-toggle-on"></i>\n		';
 } else { 
__p+='\n		<i class="fa fa-toggle-off"></i>\n		';
 } 
__p+='\n	</div>\n	<div class="MenuInline MenuLabel">\n		Automatische Selektion beim Wechsel\n	</div>\n</div>\n';
 } 
__p+='\n<div class="MenuItemPassive MenuButton" data-invoke="resetSettings" title="Alle lokal gesicherten Daten löschen (z.B. Vorauswahl Favorit). Die Favoritengruppen bleiben mit allen Einstellungen erhalten.">\n	<div class="MenuInline MenuIcon"><i class="fa fa-undo"></i></div>\n	<div class="MenuInline MenuLabel">Lokale Einstellungen zurücksetzen</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));
